import { render, staticRenderFns } from "./H4Button.vue?vue&type=template&id=53ed8eb8&"
import script from "./H4Button.vue?vue&type=script&lang=js&"
export * from "./H4Button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports